import { BANKS, INSURERS } from "@/content/site";
import { Reveal } from "@/components/Reveal";

const LogoGrid = ({ items, testId }) => (
  <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-6 items-stretch" data-testid={testId}>
    {items.map((item) => (
      <li key={item.name} className="logo-chip flex items-center justify-center bg-white rounded-md border border-[#F0F0F0] px-4 py-3">
        <img
          src={item.logo}
          alt={item.name}
          loading="lazy"
          data-testid={`logo-${item.logo.split("/").pop().replace(".svg", "")}`}
          className="h-7 md:h-8 w-auto max-w-[140px] object-contain opacity-70 grayscale hover:opacity-100 hover:grayscale-0 transition-[opacity,filter] duration-300"
        />
      </li>
    ))}
  </ul>
);

export const Institutions = () => {
  return (
    <section id="spoluprace" data-testid="institutions-section" className="py-16 md:py-20 border-t border-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <Reveal>
          <p className="flex items-center gap-4 text-xs uppercase tracking-[0.25em] text-[#737373] font-medium">
            <span className="w-10 h-[1px] bg-[#B69A58]" aria-hidden="true" />
            Hlavní partner
          </p>
          <div className="mt-8 border border-[#F0F0F0] bg-white p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-8" data-testid="partner-mm">
            <img
              src="/images/logo-mm-finance.png"
              alt="M&M Finance"
              width={543}
              height={68}
              loading="lazy"
              className="h-10 w-auto shrink-0"
            />
            <p className="text-sm md:text-base text-[#4A4A4A] leading-relaxed max-w-2xl">
              Jsem smluvně vázaný na skupinu <strong className="font-medium text-[#252525]">M&M Finance</strong>,
              dceřinou společnost <strong className="font-medium text-[#252525]">M&M Reality</strong> —
              díky tomu srovnávám nabídky napříč trhem a mám zázemí silného partnera.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.05}>
          <h2 className="font-display text-2xl md:text-3xl tracking-tight text-[#252525] mt-16 max-w-2xl">
            Srovnávám nabídky těchto bank a pojišťoven
          </h2>
          <p className="text-sm md:text-base text-[#737373] leading-relaxed mt-4 max-w-2xl">
            Nejsem vázaný na jednu instituci — vybírám z nabídek napříč trhem podle toho,
            co dává smysl právě vám.
          </p>
        </Reveal>

        <Reveal delay={0.05}>
          <h3 className="text-xs uppercase tracking-widest text-[#737373] font-medium mt-14 mb-6">
            Banky a úvěry
          </h3>
          <LogoGrid items={BANKS} testId="banks-row" />        </Reveal>

        <Reveal delay={0.1}>
          <h3 className="text-xs uppercase tracking-widest text-[#737373] font-medium mt-12 mb-6">
            Pojišťovny
          </h3>
          <LogoGrid items={INSURERS} testId="insurers-row" />
        </Reveal>
      </div>
    </section>
  );
};
